export async function submitForm(orderData) {
  const SUBMIT_ACTION_ELEMENT = document.querySelector('[data-order-action]')
  const SUBMIT_ACTION = SUBMIT_ACTION_ELEMENT ? SUBMIT_ACTION_ELEMENT.getAttribute('data-order-action') : false;

  if (!SUBMIT_ACTION) return;

  const JSON_DATA =  JSON.stringify(orderData);

  return fetch(SUBMIT_ACTION, {
    method: "POST",
    body: JSON_DATA
  });
}
